export const randInt = (min: number, max: number): number => {
    return Math.round(Math.random() * Math.abs(max - min) + min);
};
